import { cn } from "@/lib/chillnn/cn";

import { Button } from "@/components/ui/button/button";
import OpenInNew from "@/components/ui/icon/open-in-new";

type Props = {
	text: string;
} & React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>;

export const ExternalLink = ({ href, text, className, ...props }: Props) => {
	return (
		<Button variant="link-blue" className={cn("p-0 text-base", className)} icon={<OpenInNew size="sm" />}>
			<a href={href} {...props} target="_blank" rel="noopener noreferrer">
				{text}
			</a>
		</Button>
	);
};

ExternalLink.displayName = "ExternalLink";
